<div class="document-info-box-view">
    @if (infoBoxTitle) {
        <div class="title">{{ infoBoxTitle }}</div>
    }
    @if (hasDocuments) {
        <div class="document-list">
            @for (document of documents; track document) {
                <div class="document" [hidden]="document.Deleted">
                    <div class="title-bar" (click)="toggleExpanded(document)">
                        <div class="title text-truncate" [title]="document.Name">
                            {{ document.Name }}
                        </div>
                        <div class="collapse-toggle">
                            <i class="fas fa-chevron-{{ isExpanded(document) ? 'up' : 'down' }}"></i>
                        </div>
                    </div>
                    @if (isExpanded(document)) {
                        <div class="details">
                            <div class="data-grid">
                                <div class="document-buttons">
                                    @if (!document.IsNew) {
                                        <a
                                            [href]="
                                                'api/documents/manager/' + document.Guid + '/data'
                                            "
                                            target="_blank"
                                            title="Download document"
                                        >
                                            <i class="far fa-cloud-download-alt fa-fw blue"></i>
                                        </a>
                                    }
                                    <div class="separator"></div>
                                    @if (allowEdit) {
                                        <div (click)="editDocument(document)" title="Edit document">
                                            <i class="far fa-edit fa-fw"></i>
                                        </div>
                                    }
                                    @if (allowDelete) {
                                        <div
                                            (click)="deleteDocument(document)"
                                            title="Delete document"
                                        >
                                            <i class="far fa-trash fa-fw red"></i>
                                        </div>
                                    }
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="
                                        docPropertyTemplate;
                                        context: {
                                            name: 'Uploaded on',
                                            value: document.Date | dateTimeFormat,
                                        }
                                    "
                                ></ng-container>
                                <ng-container
                                    *ngTemplateOutlet="
                                        docPropertyTemplate;
                                        context: { name: 'Uploaded by', value: document.Username }
                                    "
                                ></ng-container>
                                <ng-container
                                    *ngTemplateOutlet="
                                        docPropertyTemplate;
                                        context: {
                                            name: 'Document Type',
                                            value: document.DocumentType,
                                        }
                                    "
                                ></ng-container>
                                <ng-container
                                    *ngTemplateOutlet="
                                        docPropertyTemplate;
                                        context: {
                                            name: 'Description',
                                            value: document.Description,
                                        }
                                    "
                                ></ng-container>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    } @else {
        <div class="tiny">No documents</div>
    }
</div>

@if (allowAdd) {
    <div class="document-info-box-view value full-width">
        <button
            type="button"
            class="btn btn-link p-0 border-0 fw-bold text-info"
            (click)="documentManager.openEdit()"
        >
            <span>Add document</span>
            <i class="far fa-plus fa-fw ms-2"></i>
        </button>
    </div>
}

<ng-template #docPropertyTemplate let-name="name" let-value="value">
    @if (value) {
        <div class="header">{{ name }}:</div>
        <div class="value">{{ value }}</div>
    }
</ng-template>

<div class="upload-source-document-document-manager">
    <document-manager
        [(Documents)]="documents"
        [hideLabel]="true"
        [showUi]="false"
        (DocumentsChange)="documentsChanged($event)"
        #documentManager
    ></document-manager>
</div>
